module.exports = __webpack_public_path__ + "static/media/logo1.b5577446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/QED/logo1.jpg
// module id = 176
// module chunks = 0